<!-- custom implementation of skip link to meet the following guideline -->
<!-- WCAG: A mechanism is available to bypass blocks of content that are repeated on multiple Web pages. -->

<span class="skip-link">
  <ng-container *ngFor="let link of links">
    <nv-button type="tertiary" size="normal" (click)="onSkipLinkClick(link.target)">{{ link.label }}</nv-button>
  </ng-container>
</span>
